import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const HistoricoInventariosApi = () => {
    const [cargando, setCargando] = useState(false);

    const getHistoricosInventario = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("historico_inventarios", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getFechaUltimoInventario = async () => {
        try {
            setCargando(true);
            const response = await api.get("historico_inventarios/fecha_ultimo_inventario");
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    }

    const crearInventario = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("historico_inventarios", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deleteHistoricoInventario = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`historico_inventarios/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const reabrirHistoricoInventario = async (id) => {
        try {
            setCargando(true);
            const response = await api.post(
                `historico_inventarios/${id}/reabrir_inventario`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getHistoricosInventario,
        getFechaUltimoInventario,
        crearInventario,
        deleteHistoricoInventario,
        reabrirHistoricoInventario,

        cargando,
    };
};
